const monitoring = (PROGRAMS) => {
    const block = document.getElementById('monitoring');

    if (!block) {
        return;
    }

    /* Вывод данных */
    (() => {
        const loader = document.querySelector('.monitoring__loader');
        loader.classList.remove('active');
        
        let wrap = document.createElement('div');
        wrap.classList.add('monitoring__wrap');
        wrap.append(createList(PROGRAMS.programs));
        block.append(wrap); 
    })()

    /* Создание таблицы с данными */
    function createList(data) {          

        /* Список рабочих программ */
        const WORK_PROGRAMS = [
            "basic-agronomy",
            "milling",
            "medical-care",
            "welding",
            "electric-welder",
            "car-locksmith",
            "care-assistant",
            "babysitter"
        ]

        const block = document.createElement('div'),
            tbodyOnline = document.createElement('tbody'),
            tbodyOfflineAdaptivePrograms = document.createElement('tbody'),
            tbodyOfflineWorkPrograms = document.createElement('tbody'),
            modals = document.createElement('div');
        
        block.classList.add('monitoring__block');

        if (data.length < 1) {
            block.innerHTML = `
                <p style="font-size: 20px; color: #E30016; text-align: center; font-weight: 700">Нет доступных программ!</p>
            `
        } else {
            data.forEach(function (elem) {
                const {name, shortname, regions, level, direction_id, educational_form} = elem;
                const block = document.createElement('tr');
                const arrRegions = findRegions(regions);    
                
                block.innerHTML += `
                        <td><button type="button" data-modal-id="${shortname + '-' + direction_id}" data-modal-open>${name}</button></td>
                        <td>${arrRegions.listLinkRR.length > 0 ? "<b>Да</b>" : "Нет"}</td>
                        <td>${level == 'additional_vocational' ? 'ДПО' : 'ПО'}</td>
                        <td>${shortname}</td>
                        <td>${findDirection(PROGRAMS.educational_directions, direction_id)} (id - ${direction_id})</td>
                `
                
                /* Вставляем программы с редиректом в начало */
                if (arrRegions.listLinkRR.length > 0) {
                    if (educational_form == "online") {
                        tbodyOnline.prepend(block);
                    } else {
                        if (WORK_PROGRAMS.includes(shortname)) {
                            tbodyOfflineWorkPrograms.prepend(block)
                        } else {
                            tbodyOfflineAdaptivePrograms.prepend(block)
                        }
                    }
                } else {
                    if (educational_form == "online") {
                        tbodyOnline.append(block);
                    } else {
                        if (WORK_PROGRAMS.includes(shortname)) {
                            tbodyOfflineWorkPrograms.append(block)
                        } else {
                            tbodyOfflineAdaptivePrograms.append(block)
                        }
                    }
                }

                /* Создание модального окна со списком регионов */
                const modal = document.createElement('div');
                const RegionsLinkRR = document.createElement('div');
                const RegionsNotLinkRR = document.createElement('div');

                modal.classList.add('monitoring__modal', 'custom-modal__hidden');
                modal.setAttribute('id', `${shortname + '-' + direction_id}`);             

                if (arrRegions.listLinkRR.length > 0) {
                    const title = document.createElement('h3');
                    const content = document.createElement('div');

                    arrRegions.listLinkRR.forEach((region) => {
                        if (region.cities.length > 0) {
                            let cities = '';

                            region.cities.forEach(city => {
                                cities += `<p style="color: #703EFF;">&nbsp;&nbsp; ${findName(PROGRAMS.cities, city)}</p>`;  
                                                              
                            })

                            content.innerHTML += `
                                <div style="margin-bottom: 10px">
                                    <p>${findName(PROGRAMS.regions, region.id)}</p>
                                    ${cities}
                                </div>
                            ` 
                        } else {       
                            content.innerHTML += `<p style="color: #3052d8; font-family: 'Proxima Nova - Semibold', sans-serif; font-weight: 500;">${findName(PROGRAMS.regions, region.id)}</p>`
                        }
                    })    

                    title.innerHTML = "Регионы с редиректом";
                    RegionsLinkRR.append(title);
                    RegionsLinkRR.append(content);
                    modal.append(RegionsLinkRR);
                }
                
                if (arrRegions.listNotLinkRR.length > 0) {
                    const title = document.createElement('h3');
                    const content = document.createElement('div');

                    arrRegions.listNotLinkRR.forEach((region) => {
                        if (region.cities.length > 0) {
                            let cities = '';

                            region.cities.forEach(city => {
                                cities += `<p style="color: #703EFF;">&nbsp;&nbsp; ${findName(PROGRAMS.cities, city)}</p>`;  
                                                              
                            })

                            content.innerHTML += `
                                <div style="margin-bottom: 10px">
                                    <p>${findName(PROGRAMS.regions, region.id)}</p>
                                    ${cities}
                                </div>
                            ` 
                        } else {       
                            content.innerHTML += `<p>${findName(PROGRAMS.regions, region.id)}</p>`
                        }
                    })    

                    title.innerHTML = "Регионы без редиректа";
                    RegionsNotLinkRR.append(title);
                    RegionsNotLinkRR.append(content); 
                    modal.append(RegionsNotLinkRR);    
                }             
            
                modals.append(modal);
            });
    
            block.innerHTML = `
                <h3>Количество программ - ${data.length}</h3>
                <h4>Онлайн программы</h4>
                <table>
                    <thead>
                        <tr>
                            <td>Название</td>
                            <td>Редирект</td>
                            <td>Level</td>
                            <td>Url</td>
                            <td>Направление</td>
                        </tr>
                    </thead>
                    ${tbodyOnline.innerHTML}
                </table>
                <br><br><br>
                <h4>Офлайн адаптивные программы</h4>
                <table>
                    <thead>
                        <tr>
                            <td>Название</td>
                            <td>Редирект</td>
                            <td>Level</td>
                            <td>Url</td>
                            <td>Направление</td>
                        </tr>
                    </thead>
                    ${tbodyOfflineAdaptivePrograms.innerHTML}
                </table>
                <br><br><br>
                <h4>Офлайн рабочие программы</h4>
                <table>
                    <thead>
                        <tr>
                            <td>Название</td>
                            <td>Редирект</td>
                            <td>Level</td>
                            <td>Url</td>
                            <td>Направление</td>
                        </tr>
                    </thead>
                    ${tbodyOfflineWorkPrograms.innerHTML}
                </table>
                ${modals.innerHTML}
            `
        }

        return block;
    }

    /* Поиск названия направления */
    function findDirection(hermes, id) {
        return hermes.find((element) => element.id == id).name
    }

    /* Поиск всех доступных регионов и городв */
    function findRegions(regions) {
        const listProgramRegionsLinkRR = [];
        const listProgramRegionsNotLinkRR = [];
    
        regions.forEach(element => {                   
            if (element.fields.filter(item=> item.field === "rvr_link").length > 0) {
                listProgramRegionsLinkRR.push({
                    "id": element.region_id,
                    "cities": element.cities
                });
            } else {
                listProgramRegionsNotLinkRR.push({
                    "id": element.region_id,
                    "cities": element.cities
                });
            }
        })        
    
        return {
            "listLinkRR": listProgramRegionsLinkRR,
            "listNotLinkRR": listProgramRegionsNotLinkRR
        }     
    }

    /* Возвращает название региона или города */
    function findName(arr, id) {
        return arr.filter(item => item.id == id)[0].name
    }
}

export default monitoring;